import { parseByCountry } from "./FormatInputByCountry";

const commaDecimalToDecimal = (value: any) => {
  return parseByCountry(value);
};
export default commaDecimalToDecimal;
